import logo from '../assets/images/wp-icon-new.png';

function AppLogo() {
    return <img className="w-20" style={{borderRadius: "25px"}} src={logo} alt="logo"/>
}

export default AppLogo;